export default __webpack_public_path__ + "static/media/N3WPORT - Alive (feat. Neoni) [NCS Release].4dfef221.mp3";